
// form7 - actions on form sent
//-----------------------------


// open custom Popup Alert
document.addEventListener('wpcf7mailsent', function(event) {
    formSent();
}, false);

// Function for custom Popup Alert
function formSent() {

    var title;
    var content;

    // language detect from URL
    function getLang() {
        if (window.location.href.indexOf("/es/") != -1) return 'es'; // 
        else if (window.location.href.indexOf("/en/") != -1) return 'en';
        else return 'ca'; // Default language
    }
    if (getLang() == 'en') {
         title = 'Got it!';
         content = 'We\'ll get in touch with you soon.';
    }
    if (getLang() == 'es') {
         title = 'Recibido!';
         content = 'En breve nos pondremos en contacto contigo.';
    }
    if (getLang() == 'ca') {
         title = 'Rebut!';
         content = 'En breu ens posarem en contacte amb tu.';
    }

    document.getElementById("fs_text1").innerHTML = title;
    document.getElementById("fs_text2").innerHTML = content;
    // $('#form_sent').foundation('open'); // open reveal alert
    $("#form_sent").addClass("is-visible"); // open modal alert
}





// send event to GA
// document.addEventListener('wpcf7mailsent', function(event) {
//     ga('send', 'event', 'Contact Form 7', 'Mail Sent'); // GA event
// }, false);
